import React from 'react';
import PropTypes from 'prop-types';
import StatusPill from '../../../../shared/components/pill/StatusPill';
import CountPill from '../../../../shared/components/pill/CountPill';

// Shared by every fragment-bearing step (retrieve, rerank, and whatever comes next), which is
// what lets a reranked pass render with no new component — the step only has to put its
// fragments in the same shape.
export default function FragmentList({ fragments, selectedId, citedIds, onSelect }) {
  if (!fragments || fragments.length === 0) {
    return <p className="text-muted small mb-0">No fragments in this step.</p>;
  }

  return (
    <div className="d-flex flex-column gap-1">
      {fragments.map((fragment) => {
        const cited = citedIds.includes(fragment.id);
        return (
          <button
            type="button"
            key={fragment.id}
            className={`btn btn-sm text-start border rounded p-2 ${
              fragment.id === selectedId ? 'border-primary bg-primary-subtle' : 'border-light-subtle bg-white'
            }`}
            onClick={() => onSelect(fragment.id)}
          >
            <div className="d-flex justify-content-between align-items-start gap-2">
              <span className="small fw-semibold text-truncate">
                {fragment.rank != null && (
                  <CountPill size="inline" className="me-1">#{fragment.rank}</CountPill>
                )}
                {fragment.breadcrumb || fragment.filename}
              </span>
              <span className="d-flex align-items-center gap-1 flex-shrink-0">
                {cited && (
                  <StatusPill tone="success" size="inline" title="Cited in the answer">
                    cited
                  </StatusPill>
                )}
                {fragment.distance != null && (
                  <CountPill size="inline" className="font-monospace">
                    {Number(fragment.distance).toFixed(3)}
                  </CountPill>
                )}
              </span>
            </div>
            <div className="text-muted small text-truncate">{fragment.filename}</div>
          </button>
        );
      })}
    </div>
  );
}

FragmentList.propTypes = {
  fragments: PropTypes.arrayOf(PropTypes.object),
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  citedIds: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
};

FragmentList.defaultProps = {
  fragments: [],
  selectedId: null,
  citedIds: [],
};
